import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentCalibrationQuestion on AssessmentQuestionInterface {
    id
    templateContextId
    title
    ... on RangeAssessmentQuestionNode {
      labels
      startValue
      endValue
    }
    ... on TalentIndicatorAssessmentQuestionNode {
      labels
      startValue
      endValue
    }
  }
`;
